<template>
  <div id="app">
    <template v-if="hasBooted">
      <b-container class="d-flex align-items-center flex-column">
        <Navigation v-if="!excludeNavigation" class="mt-3"></Navigation>
        <p class="bg-light mt-3 p-3 rounded-lg text-whale">
          Smart Match provides an easy way to link CRM events to the corresponding visitor and their associated marketing source, letting you link transactions to the marketing activities that drove them. Simply upload a CSV file with Caller ID, Date &amp; Time, and transaction details, and we’ll match them.
        </p>
        <Status v-if="$route.name && onUploadRoute($route.name)" class="mt-4"></Status>
        <router-view @go-to-external-route="goToExternalRoute"></router-view>
      </b-container>
    </template>
    <b-toaster name="b-toaster-top-right" />
  </div>
</template>

<script lang="ts">
import { Component, Emit, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import WebComponentRootMixin from '@infinity/intelligent-match/mixins/web-component-root'
import WebComponentAuthMixin from '@infinity/shared/mixins/web-component-auth'
import Navigation from '@infinity/intelligent-match/components/Navigation.vue'
import Status from '@infinity/intelligent-match/components/Status.vue'
import { BToaster } from 'bootstrap-vue'
import { OnUploadRoute } from '@infinity/intelligent-match/router'

@Component({
  components: {
    Navigation,
    Status,
    BToaster
  }
})
export default class App extends mixins(WebComponentRootMixin, WebComponentAuthMixin) {
  @Prop({ type: Boolean, default: false })
  excludeNavigation!: boolean

  onUploadRoute = OnUploadRoute

  async created () {
    await this.waitForBoot()
    this.$store.commit('setInstallationId', this.$infinityAuth.getInstallation().getId())
    this.$store.commit('setUploadRoutesOnly', this.excludeNavigation)
  }

  @Emit('go-to-external-route')
  goToExternalRoute (event: string) {
    return event
  }
}
</script>

<style lang="scss">
@import '~mfe-shared/app/src/styles/_base.scss';

#app {
  @extend html;
  @extend body;

  min-height: 100%;
  letter-spacing: .3px;
  fill: currentColor;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
}
</style>
